import { DropdownMenu } from '@octopus-do/octopus-storybook'
import { OctopusPurpleLogo } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'

import { CheckAccessory } from './CheckAccessory'

export const DefaultItem: React.FC = () => (
  <DropdownMenu.ContentItem left={CheckAccessory} reversed title="Default">
    <OctopusPurpleLogo />
  </DropdownMenu.ContentItem>
)
